import script from "./CoacheList.vue?vue&type=script&setup=true&lang=js"
export * from "./CoacheList.vue?vue&type=script&setup=true&lang=js"

import "./CoacheList.vue?vue&type=style&index=0&id=e33f970e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e33f970e"]])

export default __exports__